// ********************************************************
//
// IMPORT
//
// ********************************************************
import VConsole from 'vconsole'
import '@/services/ResizeService'
import '@/services/AlipayService'
import '@/helpers/Raf'
import store from '@/store'

// ********************************************************
//
// DOCUMENT
//
// ********************************************************
const loadDocument = function() {
  return new Promise((resolve) => {
    const onReady = function() {
      resolve()
    }

    if (document.readyState === 'complete') {
      onReady()
    } else {
      document.onreadystatechange = () => {
        if (document.readyState === 'complete') {
          onReady()
        }
      }
    }
  })
}

// ********************************************************
//
// APP
//
// ********************************************************
async function initApp() {
  await loadDocument()

  console.group('Initialization')

  store.commit('app/setLoadStep', 'vconsole')
  //if (store.state.app.vconsole) new VConsole()
  // new VConsole()

  store.commit('app/setLoadStep', 'alipay')
  const sysInfo = await AlipayService.init()
  if (sysInfo) store.commit('app/setSysInfo', sysInfo)

  store.commit('app/setLoadStep', 'resizing')
  store.commit('app/setSafePadding', ResizeService.safePadding)

  store.commit('app/setLoadStep', 'app')
  await import('./main')

  // store.commit('app/setLoadStep', 'fonts')
  // await FontService.load(fontManifest)

  // store.commit('app/setLoadStep', 'sound')
  // await SoundService.load(soundManifest)

  // store.commit('app/setLoadStep', 'assets')
  // await AssetService.load(assetManifest)
  //store.commit('app/setLoadStep', 'game')
  //await GameService.load()

  store.commit('app/setLoadStep', 'completed')
  //store.commit('app/setLoadComplete')

  console.groupEnd()

  //store.dispatch('app/getVersion')
}

// ********************************************************
//
// INIT
//
// ********************************************************
initApp()
// if (store.state.browser.isMobile) {
//   initApp()
// } else {
//   //import('./desktop')
// }

window.store = store
